import LabeledInput from '@intercom/embercom-composer/components/labeled-input';
export default LabeledInput;
